












































































































































































































































































































import {Component, Prop, Watch} from "vue-property-decorator";
import {FormModel} from "ant-design-vue";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import {assignValueToForm} from "@/shared/services/helper/utils";
import {CommonStatus} from "@/enums/status";
import ProvinceSelector from "@/modules/regions/ProvinceSelector/index.vue";
import DistrictSelector from "@/modules/regions/DistrictSelector/index.vue";
import MillisecondDatePicker from "@/shared/components/MillisecondDatePicker/index.vue";
import PostOfficeSelector from "@/shared/components/PostOfficeSelector/index.vue";
import EmployeeSelector from "@/shared/components/EmployeeSelector/index.vue";
import WardSelector from "@/modules/regions/WardSelector/index.vue";
import {PHONE_REGEX} from "@/shared/constant";
import {EmployeeType, FreightServiceType, PriceListType} from "@/enums/type";
import {FreightServiceStore} from "@/modules/freightservices/store";
import {FreightServiceParams} from "@/modules/freightservices/params";
import {FreightService} from "@/interfaces/entity";
import FreightServiceSelector from "@/shared/components/FreightServiceSelector/index.vue";
import PriceListSelector from "@/shared/components/PriceListSelector/index.vue";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import UploadMultipleImage from "@/shared/components/UploadMultipleImage/index.vue";
import {InsuranceFeeParams} from "@/modules/customers/params";
import InputCurrency from "@/shared/components/InputCurrency/index.vue";
import AInputCustom from "@/shared/components/CustomInputAnt/index.vue";
import {CustomerRegisterStore} from "@/modules/customerregister/store";
import {ShowWeightType} from "@/enums/type/showweight";

const dvkh = {
    freightServiceRowGuid: undefined,
    priceListId: undefined
};

const form = {
    id: undefined,
    username: "",
    password: undefined,
    customerCode: "",
    fullName: "",
    billAddress: "",
    identityCard: "",
    identityCardImages: "",
    identityCardImagesUrl: "",
    contact: "",
    phoneNumber: "",
    email: "",
    sender: "",
    senderPhone: "",
    address: "",
    wardId: undefined,
    districtId: undefined,
    provinceId: undefined,
    contractCode: "",
    contractStartDate: undefined,
    contractEndDate: undefined,
    employeeRowGuid: undefined,
    postOfficeRowGuid: undefined,
    status: 1,
    discount: undefined,
    priceListType: PriceListType.Default,
    serviceCustomers: [] as any,
    insuranceFee: {
        priceMark: 0,
        freightAboveByPercent: 0,
        minPrice: 0
    },
    showWeight: undefined
};

@Component({
    name: "CustomerRegisterForm",
    components: {
        AInputCustom,
        InputCurrency,
        UploadMultipleImage,
        PriceListSelector,
        FreightServiceSelector,
        WardSelector,
        EmployeeSelector,
        PostOfficeSelector, MillisecondDatePicker, DistrictSelector, ProvinceSelector, EnumSelector
    },
})
export default class extends mixins(CommonMixin) {
    @Prop()
    readonly id!: number;
    ShowWeightType = ShowWeightType;
    CommonStatus = CommonStatus;
    PriceListType = PriceListType;
    FreightServiceType = FreightServiceType;
    EmployeeType = EmployeeType;
    private form = {...form, insuranceFee: new InsuranceFeeParams()};
    customerRegister?: any = undefined;
    priceListLimit = 50;
    
    pathToUrl = (path: string) => `${process.env.VUE_APP_BASE_URL}upload/${path}`;
    
    private rules = {
        username: [{required: true, message: "Nhập tài khoản", trigger: "change"}],
        password: [{required: true, message: "Nhập mật khẩu", trigger: "change"}],
        customerCode: [{required: true, message: "Nhập mã khách hàng", trigger: "change"}],
        fullName: [{required: true, message: "Nhập họ tên", trigger: "change"}],
        billAddress: [{required: true, message: "Nhập địa chỉ thanh toán", trigger: "change"}],
        identityCard: [{required: true, message: "Nhập CCCD/CMND", trigger: "change"}],
        contact: [{required: true, message: "Nhập liên hệ", trigger: "change"}],
        phoneNumber: [
            {required: true, message: "Nhập số điện thoại", trigger: "change"},
            {pattern: new RegExp(PHONE_REGEX), message: "Số điện thoại không đúng định dạng", trigger: "change"}
        ],
        email: [{required: true, message: "Nhập email", trigger: "change"}],
        sender: [{required: false, message: "Nhập người gửi", trigger: "change"}],
        senderPhone: [
            {required: false, message: "Nhập số điện thoại người gửi", trigger: "change"},
            {pattern: PHONE_REGEX, message: "Số điện thoại không đúng định dạng", trigger: "change"}
        ],
        address: [{required: true, message: "Nhập địa chỉ", trigger: "change"}],
        wardId: [{required: true, message: "Chọn phường/xã", trigger: "change"}],
        districtId: [{required: true, message: "Chọn quận/huyện", trigger: "change"}],
        provinceId: [{required: true, message: "Chọn tỉnh/tp", trigger: "change"}],
        contractCode: [{required: true, message: "Nhập mã hợp đồng", trigger: "change"}],
        contractStartDate: [{required: true, message: "Chọn ngày bắt đầu hợp đồng", trigger: "change"}],
        contractEndDate: [{required: false, message: "Chọn ngày kết thúc hợp đồng", trigger: "change"}],
        postOfficeRowGuid: [{required: false, message: "Chọn bưu cục phục vụ", trigger: "change"}],
        employeeRowGuid: [{required: true, message: "Chọn nhân viên phục vụ", trigger: "change"}],
        rateFee: [{required: true, message: "Nhập tỉ lệ tính giá", trigger: "change"}],
        insuranceFee: {
            priceMark: [{required: true, message: "Nhập nấc tính cước", trigger: "change"}],
            minPrice: [{required: true, message: "Nhập cước tối thiểu", trigger: "change"}],
            freightAboveByPercent: [{required: true, message: "Nhập cước tính trên nấc", trigger: "change"}]
        },
        showWeight: [{required: true, message: "Chọn hiển thị trọng lượng"}]
    };
    
    rulesGuest = {
        customerCode: [{required: true, message: "Nhập mã khách hàng", trigger: "change"}],
    };
    
    private onSubmit() {
        (this.$refs.formCustomerRegister as FormModel).validate(async valid => {
            if (!valid) return;
            const originServiceCustomers = this.form.serviceCustomers;
            if (this.form.priceListType === PriceListType.Default) {
                this.form.serviceCustomers = [];
            } else {
                this.form.serviceCustomers = this.form.serviceCustomers.filter((serviceCustomer: any) => serviceCustomer.priceListId);
            }
            try {
                await CustomerRegisterStore.confirmCustomerRegister(this.form)
                
                this.$notification.success({
                    message: "Thành công",
                    description: `Xác nhận khách hàng thành công`
                });
                this.$router.push({name: "customerRegisters"});
            } catch (e) {
                this.form.serviceCustomers = originServiceCustomers;
                this.$notification.error({
                    message: "Thất bại",
                    description: `${e.response?.data?.message || `Xác nhận khách hàng thất bại`}`
                })
            }
        })
    }
    
    async created() {
        if (this.isAdmin) {
            this.rules = { ...this.rules, postOfficeRowGuid: [{required: true, message: "Chọn bưu cục phục vụ", trigger: "change"}], }
        }
        if (this.id) {
            this.rules.password = [{required: false} as any];
            try {
                this.customerRegister = await CustomerRegisterStore.singleCustomerRegister(this.id);
                this.form = assignValueToForm(this.form, { ...this.customerRegister || {} });
                this.form.status = CommonStatus.Active
            } catch (e) {
                console.log(e);
                this.$message.error(`${e.response?.data?.message || "Đã có lỗi xảy ra"}`)
            }
        }
        if (this.isAdmin) {
            this.rulesGuest['postOfficeRowGuid'] = [{required: true, message: "Chọn bưu cục", trigger: "change"}]
        }
    }
    
    mappingServiceCustomers(serviceCustomers: Array<any>, services: Array<FreightService>) {
        return services.map((service: FreightService) => {
            const serviceCustomer = serviceCustomers?.find((sc: any) => sc.freightServiceRowGuid === service.rowGuid);
            return {
                freightServiceRowGuid: service.rowGuid as any,
                priceListId: serviceCustomer?.priceListId
            };
        });
    }
    
    
    async listFreightServiceByPostOffice() {
        try {
            const params = {
                ...new FreightServiceParams(),
                type: FreightServiceType.NORMAL,
                limit: 200,
                status: CommonStatus.Active,
                postOfficeRowGuid: this.form.postOfficeRowGuid ? this.form.postOfficeRowGuid : this.currentPostOffice?.rowGuid
            };
            return await FreightServiceStore.listFreightService({ params });
        } catch (e) {
        }
    }
    
    async changePriceListType($evt: any) {
        const value = $evt.target.value;
        if (value === PriceListType.Option) {
            const freightServices = await this.listFreightServiceByPostOffice();
            this.form.serviceCustomers = this.mappingServiceCustomers(this.customerRegister?.serviceCustomers, freightServices);
        }
    }
    
    @Watch("form.postOfficeRowGuid", { deep: true })
    async changePostOffice(val: any) {
        const freightServices = await this.listFreightServiceByPostOffice();
        this.form.serviceCustomers = this.mappingServiceCustomers(this.customerRegister?.serviceCustomers, freightServices);
    }
}
